module.exports = __webpack_public_path__ + "media/images/lp/1/description1-sp-e8fccec37b4c9fa19ca4fb59b85ea7dd.jpg";